(function () {
  'use strict';
  if (window.__solenneBehavior || (window.Shopify && window.Shopify.designMode)) return;
  var params = new URLSearchParams(window.location.search);
  if (params.has('pdpx') || params.has('preview_theme_id')) return;
  window.__solenneBehavior = true;
  var counts = Object.create(null);

  function emit(name) {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
          privacy.analyticsProcessingAllowed() !== true || typeof window.clarity !== 'function') return;
      if ((counts[name] || 0) >= 20) return;
      window.clarity('event', 'solenne_' + name);
      counts[name] = (counts[name] || 0) + 1;
    } catch (_) {}
  }

  function start() {
    document.addEventListener('click', function (event) {
      var el = event.target instanceof Element ? event.target : null;
      if (!el) return;
      if (el.closest('#barAdd')) emit('pdp_add_attempt');
      if (el.closest('button[name="checkout"]')) emit('checkout_click');
      if (el.closest('#sw .sw')) emit('colour_choice');
      if (el.closest('#galB, #galF, #galStrip')) emit('gallery_control');
      var tier = el.closest('.tier[data-q]');
      if (tier && /^(1|2|3)$/.test(tier.dataset.q)) emit('quantity_choice_' + tier.dataset.q);
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target.id === 'buyForm') emit('pdp_add_attempt');
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target.matches('#bundleColours select')) emit('bundle_colour_choice');
    });

    function observeState(selector, attributes, active, eventName) {
      var node = document.querySelector(selector);
      if (!node) return;
      var previous = active(node);
      new MutationObserver(function () {
        var current = active(node);
        if (current && !previous) emit(eventName);
        previous = current;
      }).observe(node, { attributes: true, attributeFilter: attributes });
    }

    observeState('#sgOv', ['class'], function (n) { return n.classList.contains('on'); }, 'size_guide_open');
    observeState('#sol-cart-ov', ['aria-hidden'], function (n) { return n.getAttribute('aria-hidden') === 'false'; }, 'cart_open');

    function observeError(selector, pdp) {
      var node = document.querySelector(selector);
      if (!node) return;
      var previous = '';
      new MutationObserver(function () {
        var name = '';
        if (!node.hidden && node.textContent.trim()) {
          name = pdp ? (document.querySelector('#bundleColours [aria-invalid="true"]') ?
            'bundle_colour_required' : 'pdp_add_error') : 'cart_error';
        }
        if (name && name !== previous) emit(name);
        previous = name;
      }).observe(node, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true, characterData: true });
    }
    observeError('#cartError', true);
    observeError('#sol-cart-error', false);

    var delivery = document.getElementById('delivery-details');
    if (delivery) {
      var wasOpen = delivery.open;
      delivery.addEventListener('toggle', function () {
        if (delivery.open && !wasOpen) emit('delivery_details_open');
        wasOpen = delivery.open;
      });
    }

    if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var privacy = window.Shopify && window.Shopify.customerPrivacy;
          if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
          emit(entry.target.id === 'buyForm' ? 'pdp_buy_controls_seen' : 'pdp_quantity_seen');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.2 });
      document.querySelectorAll('#buyForm, .pdp-ladder').forEach(function (n) { observer.observe(n); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
